(function (angular, app) {
   "use strict";
   
   // PasswordController
   angular.module(app.modules.ui.name)
      .controller(app.modules.ui.controllers.password, PasswordController);
    
   // Injector  
   PasswordController.$inject = ["$scope"
      , app.modules.common.services.functions
   , app.modules.ui.services.ui
   ];
   
   //
   function PasswordController($scope
      , ggFunctions
      , ggUISvc) {
      
      var ctrl = this;
      
      $scope.Temp = {
         window: ggFunctions.fetchWindowSize()
      }

      ctrl.form = {
         EmailAddress: app.Member.Auth.userName
      }
      ctrl.alert = "";
      ctrl.isProcessing = false;
      ctrl.isComplete = false;
      
      // Request a New Password -> Member Service
      ctrl.request = function(){

         var data = {
            username : ctrl.form.EmailAddress
         }

         ctrl.isProcessing = true;
         app.Member.Network.ResetPassword(data).then(function (data) {
            if (data && data.status == "204") {
               ctrl.alert = "A new password has been sent to your email address.";
               ctrl.isComplete = true;
               app.Member.Auth.userName = ctrl.form.EmailAddress
            }
         }).finally(function () { ctrl.isProcessing = false;})
         
      }

      ctrl.login = function () {
         ggUISvc.modal.open.login();
      }

      // Cancel Button, Close Modal
      ctrl.cancel = function(){
         ggUISvc.modal.open.close();
      }
   }
}(angular, app));
